import Fab from "@material-ui/core/Fab";
import { StyleRulesCallback, withStyles, WithStyles } from "@material-ui/core/styles";
import cx from "classnames";
import React from "react";

import { ButtonProps } from "../types";

const styles: StyleRulesCallback = ({ spacing, zIndex }) => ({
  root: {
    minHeight: "48px",
    minWidth: "194px"
  },
  sticky: {
    bottom: 0,
    left: 0,
    margin: `0 auto ${spacing.unit * 3}px`,
    maxWidth: "278px",
    minWidth: "255px",
    position: "fixed",
    right: 0,
    width: "100%",
    zIndex: zIndex.snackbar
  }
});

const BaseButton: React.FC<ButtonProps & WithStyles<typeof styles>> = ({
  text,
  url,
  onClick,
  classes,
  isSticky,
  disabled
}) => (
  <Fab
    variant="extended"
    color="primary"
    href={!Boolean(onClick) ? url : undefined}
    onClick={onClick}
    classes={{ root: classes.root }}
    className={cx({ [classes.sticky]: isSticky })}
    disabled={disabled}
  >
    {text}
  </Fab>
);

BaseButton.defaultProps = {
  isSticky: false
};

export const Button = withStyles(styles)(BaseButton);
